module.exports = __webpack_public_path__ + "static/media/mapa-cobertura@3x.3f538e19.png";